/**
 * Packed 0xRRGGBB for Phaser (outlines, username highlight, etc.).
 * Matches default theme `secondary` in `@workadventure/design-system` (`dist/theming/themes.js`, `[data-theme=default]`).
 */
export const PHASER_COLOR_DESIGN_SYSTEM_SECONDARY = 0x4156f6;
